var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 391.92,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.33,
    y: 389.21,
    width: 43.5,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.58,
    y: 397.08,
    width: 38.75,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.71,
    y: 399.53,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379,
    y: 399.53,
    width: 18.8,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.44,
    y: 395.31,
    width: 36.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.32,
    y: 258.61,
    width: 20.81,
    height: 123.79,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.18 382.4 337.13 382.4 337.13 371.16 329.04 371.16 333.18 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.73,
    y: 258.61,
    width: 20.81,
    height: 123.79,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.09,
    y: 258.61,
    width: 108.05,
    height: 116.89,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.07,261.68H232.15v22.14H334.07V261.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.07,286.36H284.44v75.09h49.63V286.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.78,286.36H232.15v75.09h49.63V286.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.68,294.29a3.52,3.52,0,1,0,3.51-3.51A3.52,3.52,0,0,0,270.68,294.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.02,
    cy: 294.29,
    r: 3.51,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.04 382.4 229.09 382.4 229.09 371.16 237.18 371.16 233.04 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,272.91a3.52,3.52,0,1,0,3.51-3.52A3.51,3.51,0,0,0,280.06,272.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.47,
    y: 258.61,
    width: 20.81,
    height: 123.79,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.33 382.4 224.28 382.4 224.28 371.16 216.19 371.16 220.33 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.87,
    y: 258.61,
    width: 20.81,
    height: 123.79,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.23,
    y: 258.61,
    width: 108.05,
    height: 116.89,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.22,261.68H171.58v99.77h49.64V261.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,261.68H119.3v99.77h49.63V261.68Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.83,269.61a3.52,3.52,0,1,0,3.51-3.51A3.52,3.52,0,0,0,157.83,269.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.66,269.61a3.52,3.52,0,1,0,3.51-3.51A3.52,3.52,0,0,0,175.66,269.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.19 382.4 116.23 382.4 116.23 371.16 124.33 371.16 120.19 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.26,
    y: 79.55,
    width: 83.95,
    height: 92.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.38,
    y: 79.55,
    width: 90.02,
    height: 92.17,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.04,
    y: 86.37,
    width: 80.69,
    height: 78.54,
    transform: "translate(447.02 -195.75) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.63,154.33h0a24,24,0,0,1,0-33.87l23.52-23.52h0a24,24,0,0,1,0,33.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.81,
    y: 142.67,
    width: 49.68,
    height: 56.07,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.02,
    y: 142.67,
    width: 55.65,
    height: 56.07,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.55,
    y: 148.62,
    width: 44.59,
    height: 44.17,
    transform: "translate(580.56 -239.14) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.62,
    y: 161.48,
    width: 18.46,
    height: 18.46,
    rx: 5.65,
    transform: "translate(820.36 1.61) rotate(135)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,362.53h1.48c0-6.3,0-8.42.15-45.07.27-66.43.78-70.48.78-70.48l-3.52,30.67C411.64,311.61,414.52,331.85,415,362.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.2,382.4H407.1c-9.61,0-10.17-6.75-12.15-15.88a41.39,41.39,0,0,0-2.05-7.09l-.15-.37h43.8l-.15.37a42.31,42.31,0,0,0-2,7.09C432.38,375.65,431.81,382.4,422.2,382.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.62,361.28H391.69a2,2,0,0,1-2-1.76l-.88-6.67a2,2,0,0,1,2-2.29H438.5a2,2,0,0,1,2,2.29l-.88,6.67A2,2,0,0,1,437.62,361.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.72,300.91c8.64-15.06-13.77-20.45-21-33.87C384,277.64,403.59,318.55,413.72,300.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,283.89c-3.33-7.59,12.72-16.8,16.18-29.14C438,261.88,425.25,306.36,415.38,283.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25,262.69c2.15-17.5-9.25-16-14-26.46C395.17,243.71,414.58,276.2,416.25,262.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.6,256.43c-2.91-13.33,6.82-11.24,5.55-24.39C432.49,242,419.07,272.32,415.6,256.43Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.26,310.81c2.71-9.57,18.25-2.67,26.18-20.64C449.87,315.55,407.72,337.37,415.26,310.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,323.76c-.23-9.1-10.05-1-28-17.22C384.79,323.25,416.51,346.24,416,323.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.75,
    y: 79.55,
    width: 149.24,
    height: 155.68,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.93,
    y: 79.55,
    width: 149.24,
    height: 155.68,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.72,
    y: 90.28,
    width: 141.66,
    height: 134.23,
    transform: "translate(299.95 14.84) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.26,
    y: 155.81,
    width: 141.66,
    height: 3.16,
    transform: "translate(365.48 -50.7) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.04,
    y: 186.15,
    width: 143.03,
    height: 9.41,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.04,
    y: 98.92,
    width: 143.03,
    height: 9.41,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-5",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.52,173.88a19.84,19.84,0,0,0-10.24-.57c-2.29.36-6.21-1.69-8.86-4.93A5.12,5.12,0,0,0,87,174.31c-3.53,2.5-10.1-.27-10.85-4.88s4.29-4.57,1.21-12.65,5.11-4.49,7.74-16.51,15.58-11,17.73-6.55c7.43-3.06,11.12,1.44,14,8.22,2.51,6,2,10.69,5.71,20.63C126,172,112.14,176.88,101.52,173.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,173.39a4.12,4.12,0,0,1-1.35-.26A9.68,9.68,0,0,1,81.28,167a.25.25,0,1,1,.48-.14,9.17,9.17,0,0,0,5.1,5.84,2.51,2.51,0,0,0,2.23-.07.25.25,0,0,1,.35.06.25.25,0,0,1-.07.35A2.27,2.27,0,0,1,88,173.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.86,154.52h0a.26.26,0,0,1-.21-.29c1.4-8,.12-14.25-3.59-17.65a9.06,9.06,0,0,0-8.5-2.11.25.25,0,0,1-.31-.18.24.24,0,0,1,.18-.3,9.57,9.57,0,0,1,9,2.22c2.23,2,5.67,7.1,3.75,18.1A.26.26,0,0,1,118.86,154.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,237.48s0,54-3.28,83.26c-.34,27.46-6.61,89.5-6.61,89.5h-6.93c-1.16-30.78-9.74-59.52-4-86.67-13.33-53.32-7.14-86-7.14-86Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.85,237.52S103.53,297.42,99.62,323c-4.11,26.81-10.24,78.83-10,87.29h-6s-10-52.62-.74-86.36c-7.68-75.86,8.3-86.36,8.3-86.36Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.82,189.6c-.07,2.64-.21,5.28-.32,7.92s-.27,5.28-.43,7.92c-.32,5.27-.7,10.55-1.11,15.82l-.11-1.17.55,3.34c.19,1.11.33,2.24.5,3.37s.3,2.27.42,3.41.23,2.29.28,3.45h0a2.29,2.29,0,0,1-4.28,1.22c-.57-1-1.06-2.09-1.57-3.14s-.94-2.11-1.39-3.18-.86-2.15-1.25-3.23-.79-2.18-1.15-3.29a2.71,2.71,0,0,1-.12-.79v-.38c.06-5.29.15-10.57.31-15.85.07-2.64.17-5.28.28-7.92s.22-5.27.39-7.91h0a4.5,4.5,0,0,1,9,.41Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4,178.45c6.31,4.24,9,13.53,9.14,19.36-2.83,6.05-13,7-13,7s-2.93-10.89-2.68-16.2S118.76,176,122.4,178.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.66,188.19a11.68,11.68,0,0,0-11-11.65c-1.71-.11-3.5-.2-5.23-.22a111.17,111.17,0,0,0-16,1.19c-1.51.18-3,.41-4.39.66a9.1,9.1,0,0,0-7.24,11.21c5.8,21.87,6.61,37.87,4.4,47.68,0,0-7,9.31-10.14,30.65C75.35,286.35,78,318.37,75,335.25c10.86,7.77,43.38,6.71,48.48,2.16-1.44-34.14,5.54-78.87.23-99.52,2.13-11.45,2.67-24,3.1-31C134.15,200.59,127.65,196.32,127.66,188.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,238.1c-3-1.3-1.84-5.92-1.84-5.92l-.69-2.61a1.62,1.62,0,0,1,1.37-2.15l1.72-.22a3.26,3.26,0,0,1,3.15,1.85l.39.85a6.69,6.69,0,0,1,.5,4.35L127,236.3a3.12,3.12,0,0,1-.6,1.24,3,3,0,0,1-3.51.56Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,308.43c-.95-13.74,0-34.29,8.4-45.81C109.8,277.23,103.6,308.43,103.6,308.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.13,159.46c1.28,5,2.77,14.36-.65,18a42.68,42.68,0,0,1,21,14.85c3.75-12-5.06-16-5.06-16-5.79-.94-5.86-5.19-5.07-9.24Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.3,162.57l6,4.5a15.81,15.81,0,0,0-.34,2.86c-2.21-.15-5.33-2.32-5.68-4.59A7.54,7.54,0,0,1,100.3,162.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.23,150.47c2.44,8.18,3.3,11.7,8.43,14.91,7.71,4.84,17.1-.13,17.13-8.92,0-7.92-4-20-12.75-21.24S87.8,142.29,90.23,150.47Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,134.35c6.28,8-9.64,5.77-8.14,12.49s-6.73,8.3-4.79,13.44C79.73,158.62,84.7,130.16,102.65,134.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.86,135.1c1.48,5.18,8.22,2.91,11.91,5.92C112.05,135.1,102.71,132.82,100.86,135.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11,149.7c.16.68.65,1.14,1.09,1s.68-.75.52-1.42-.64-1.14-1.09-1S102,149,102.11,149.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51,147.7c.15.68.64,1.13,1.09,1s.68-.75.52-1.43-.65-1.13-1.09-1S110.35,147,110.51,147.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.84,146.36l1.53-.89S111.82,147,110.84,146.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93,148.8a17.91,17.91,0,0,0,3.43,3.7,3.08,3.08,0,0,1-2.32,1.07Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.19,158.68a5.35,5.35,0,0,0,4.07,1.9c2-.05,2.32-2.33,1.23-4.2-1-1.69-3.19-3.69-4.92-2.73S88.84,157.14,90.19,158.68Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.52,146.8a.45.45,0,0,0,.22-.25,3.39,3.39,0,0,1,2.06-2.18.41.41,0,0,0,.29-.5.39.39,0,0,0-.5-.28,4.18,4.18,0,0,0-2.63,2.72.4.4,0,0,0,.26.51A.44.44,0,0,0,100.52,146.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.58,143.66a.42.42,0,0,0,.32-.69,4,4,0,0,0-3.45-1.35.42.42,0,0,0-.35.47.41.41,0,0,0,.46.34,3.16,3.16,0,0,1,2.73,1.1A.37.37,0,0,0,113.58,143.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.44,148.36l1.53-.88S103.43,149,102.44,148.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.68,239.44l6.94,3.23-5.82,6.55s-4.43-3.52-5.55-7.57l.43-1.11C97.09,239.27,97.84,239,99.68,239.44Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.15,248.38l-2.88,2.47a2.18,2.18,0,0,1-3-.12l-1.52-1.51,5.82-6.55,1.92,2.85A2.16,2.16,0,0,1,108.15,248.38Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.16,189.37c-1.65,5.07-3.33,10.22-4.89,15.32-.77,2.56-1.5,5.12-2.17,7.65-.33,1.26-.64,2.52-.89,3.75a25.26,25.26,0,0,0-.54,3.37c-.16,1.32.58,3.38,1.8,5.34A37.18,37.18,0,0,0,90,230.61a70.65,70.65,0,0,0,5.62,5.44c2,1.75,4,3.47,6.09,5.07l.07,0a2.23,2.23,0,0,1-2.39,3.75,74.54,74.54,0,0,1-14.11-9.37,40,40,0,0,1-6.13-6.48,23.47,23.47,0,0,1-2.5-4.23,13.73,13.73,0,0,1-1.2-5.52,30,30,0,0,1,.42-4.72c.23-1.45.5-2.86.79-4.24.58-2.76,1.28-5.46,2-8.13,1.46-5.35,3.09-10.57,4.94-15.8a4.5,4.5,0,0,1,8.52,2.89Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.89,179.39c-5,2.35-7.29,5.91-11.09,15.72,1.33,6.54,12.92,10.41,12.92,10.41a76.13,76.13,0,0,0,4.09-12.44C94.82,187.86,93,177,87.89,179.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.05,410.29a.6.6,0,0,1,.62-.39l6.44-.09a3.52,3.52,0,0,1,1.94.41,24.31,24.31,0,0,0,9.69,3.46c1.37.21.75,2.52-2.47,2.55-5.33.06-6.29-.34-10.83-.29-3.89,0-2,.22-5.12.29-.74,0-1.35-.46-1.25-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.86,410.29a.62.62,0,0,1,.63-.39l5.24-.09a3.46,3.46,0,0,1,1.93.41c1.88,1.31,1.64,2.81,6,3.46,1.37.21.7,2.52-2.53,2.55-5.32.06-5-.29-7.16-.29s-.84.22-3.93.29c-.74,0-1.33-.46-1.22-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,188.26c-2.45-.63-7.67-.2-10.36,2.93-5.17-2-10.12-9.12-10-13.6a6.25,6.25,0,0,1,3.88-1.68S108.2,181.56,113,188.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38,187.88s.72-5.91-6.43-11.65c.72-.59,3.55.08,3.55.08s8.36,3.59,8.11,12.9A7.17,7.17,0,0,0,117.38,187.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.89,156.18a7.32,7.32,0,0,1-1.18-.65.22.22,0,0,1,0-.32.26.26,0,0,1,.34-.06,6.77,6.77,0,0,0,5.83.85.23.23,0,1,1,.16.43A7.18,7.18,0,0,1,103.89,156.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.35,173.88a19.84,19.84,0,0,0-10.24-.57c-2.29.36-6.21-1.69-8.86-4.93a5.12,5.12,0,0,0,4.58,5.93c-3.53,2.5-10.1-.27-10.85-4.88s4.29-4.57,1.21-12.65,5.11-4.49,7.74-16.51,15.58-11,17.73-6.55c7.43-3.06,11.12,1.44,14,8.22,2.51,6,2,10.69,5.71,20.63C219.87,172,206,176.88,195.35,173.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.87,173.39a4.12,4.12,0,0,1-1.35-.26,9.68,9.68,0,0,1-5.41-6.17.25.25,0,1,1,.48-.14,9.17,9.17,0,0,0,5.1,5.84,2.51,2.51,0,0,0,2.23-.07.25.25,0,0,1,.35.06.25.25,0,0,1-.07.35A2.27,2.27,0,0,1,181.87,173.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.69,154.52h0a.26.26,0,0,1-.21-.29c1.4-8,.12-14.25-3.59-17.65a9.06,9.06,0,0,0-8.5-2.11.25.25,0,0,1-.31-.18.24.24,0,0,1,.18-.3,9.57,9.57,0,0,1,9,2.22c2.23,2,5.67,7.1,3.75,18.1A.26.26,0,0,1,212.69,154.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.63,237.48s0,54-3.29,83.26c-.33,27.46-6.6,89.5-6.6,89.5h-6.93c-1.17-30.78-9.74-59.52-4.05-86.67-13.32-53.32-7.14-86-7.14-86Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.68,237.52s-11.32,59.9-15.23,85.43c-4.11,26.81-10.24,78.83-9.95,87.29h-6s-10.05-52.62-.74-86.36c-7.68-75.86,8.3-86.36,8.3-86.36Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.65,189.31c.1,2.63.11,5.23.14,7.85s0,5.22,0,7.84c-.08,5.23-.25,10.45-.65,15.78l-.11-1.17c.15.88.31,1.79.55,2.72s.49,1.87.81,2.81.62,1.91,1,2.87.72,2,1,2.88l.07.2a2.27,2.27,0,0,1-3.69,2.4,28.74,28.74,0,0,1-2.41-2.57,32.45,32.45,0,0,1-2.07-2.82,27.76,27.76,0,0,1-3.16-6.52,2.56,2.56,0,0,1-.12-.76v-.42c.05-5.05-.07-10.24-.14-15.4l-.12-7.76-.07-7.76a4.5,4.5,0,0,1,9-.21Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.23,178.45c6.31,4.24,9,13.53,9.14,19.36-2.83,6.05-13,7-13,7s-2.93-10.89-2.68-16.2S212.59,176,216.23,178.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.49,188.19a11.68,11.68,0,0,0-11-11.65c-1.71-.11-3.5-.2-5.23-.22a111.17,111.17,0,0,0-15.95,1.19c-1.51.18-3,.41-4.39.66a9.1,9.1,0,0,0-7.24,11.21c5.8,21.87,6.61,37.87,4.4,47.68,0,0-7,9.31-10.14,30.65-2.76,18.64-.09,50.66-3.11,67.54,10.86,7.77,45.1,6.71,50.2,2.16-1.44-34.14,6.07-76.72.77-97.37,5.32-8,1.36-25.7,0-33C227.13,200.74,221.48,196.32,221.49,188.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.17,240.81A44.79,44.79,0,0,1,203,242.16S212.42,244.48,215.17,240.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,234c-3-1.3-1.84-5.92-1.84-5.92l-.69-2.62a1.61,1.61,0,0,1,1.37-2.14l1.72-.23a3.27,3.27,0,0,1,3.15,1.86l.39.84a6.71,6.71,0,0,1,.5,4.35l-.49,2.05a3.38,3.38,0,0,1-.6,1.25,3,3,0,0,1-3.51.56Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,308.43c-1-13.74,0-34.29,8.39-45.81C204.94,277.23,198.74,308.43,198.74,308.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,159.46c1.28,5,2.77,14.36-.65,18a42.68,42.68,0,0,1,21,14.85c3.75-12-5.06-16-5.06-16-5.79-.94-5.86-5.19-5.07-9.24Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.13,162.57l6.05,4.5a16.76,16.76,0,0,0-.34,2.86c-2.21-.15-5.33-2.32-5.68-4.59A7.54,7.54,0,0,1,194.13,162.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,150.47c2.44,8.18,3.3,11.7,8.43,14.91,7.71,4.84,17.1-.13,17.13-8.92,0-7.92-4-20-12.75-21.24S181.63,142.29,184.06,150.47Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.48,134.35c6.28,8-9.64,5.77-8.14,12.49s-6.73,8.3-4.79,13.44C173.56,158.62,178.53,130.16,196.48,134.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,135.1c1.48,5.18,8.22,2.91,11.91,5.92C205.88,135.1,196.54,132.82,194.69,135.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.94,149.7c.16.68.65,1.14,1.09,1s.68-.75.52-1.42-.64-1.14-1.09-1S195.78,149,195.94,149.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.34,147.7c.15.68.64,1.13,1.09,1s.68-.75.52-1.43-.65-1.13-1.09-1S204.18,147,204.34,147.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.67,146.36l1.53-.89S205.65,147,204.67,146.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,148.8a17.91,17.91,0,0,0,3.43,3.7,3.08,3.08,0,0,1-2.32,1.07Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,158.68a5.35,5.35,0,0,0,4.07,1.9c2-.05,2.32-2.33,1.23-4.2-1-1.69-3.19-3.69-4.92-2.73S182.67,157.14,184,158.68Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,146.8a.45.45,0,0,0,.22-.25,3.39,3.39,0,0,1,2.06-2.18.41.41,0,0,0,.29-.5.39.39,0,0,0-.5-.28,4.18,4.18,0,0,0-2.63,2.72.4.4,0,0,0,.26.51A.44.44,0,0,0,194.35,146.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.41,143.66a.42.42,0,0,0,.32-.69,4,4,0,0,0-3.45-1.35.42.42,0,0,0-.35.47.41.41,0,0,0,.46.34,3.16,3.16,0,0,1,2.73,1.1A.37.37,0,0,0,207.41,143.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.27,148.36l1.53-.88S197.26,149,196.27,148.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.45,238.11l7.58,1.08-3.68,7.95s-5.26-2.09-7.5-5.65l.09-1.18C193.93,238.69,194.55,238.18,196.45,238.11Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,244.23l-2.05,3.19a2.19,2.19,0,0,1-2.86.74l-1.89-1,3.68-7.95,2.66,2.18A2.18,2.18,0,0,1,207.15,244.23Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06,189.14c-1.39,5.19-2.81,10.45-4.13,15.65-.64,2.61-1.26,5.22-1.82,7.8-.28,1.28-.52,2.57-.73,3.81-.1.62-.19,1.23-.26,1.81a13.68,13.68,0,0,0-.11,1.52c-.08,1.28.8,3.23,2.22,5.06a37.91,37.91,0,0,0,5.18,5.3,72.91,72.91,0,0,0,6.23,4.8c2.16,1.52,4.44,3,6.66,4.36l.08.05a2.23,2.23,0,0,1-2,4,74.52,74.52,0,0,1-15.13-7.8,39,39,0,0,1-6.84-5.83,21.21,21.21,0,0,1-2.93-4,13.24,13.24,0,0,1-1.66-5.51,21.81,21.81,0,0,1,0-2.57c0-.78.1-1.53.18-2.27.16-1.47.37-2.88.6-4.28.45-2.8,1-5.53,1.62-8.24,1.2-5.44,2.56-10.76,4.14-16.1a4.5,4.5,0,0,1,8.66,2.44Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.72,179.39c-5,2.35-7.29,5.91-11.09,15.72,1.33,6.54,12.92,10.41,12.92,10.41a76.13,76.13,0,0,0,4.09-12.44C188.65,187.86,186.8,177,181.72,179.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27,410.29a.62.62,0,0,1,.63-.39l6.44-.09a3.54,3.54,0,0,1,1.94.41,24.25,24.25,0,0,0,9.69,3.46c1.37.21.75,2.52-2.47,2.55-5.33.06-6.29-.34-10.84-.29-3.88,0-2,.22-5.12.29-.74,0-1.34-.46-1.24-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,410.29a.62.62,0,0,1,.63-.39l5.24-.09a3.46,3.46,0,0,1,1.93.41c1.88,1.31,1.64,2.81,6,3.46,1.37.21.7,2.52-2.53,2.55-5.32.06-5-.29-7.16-.29s-.84.22-3.93.29c-.74,0-1.33-.46-1.22-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,188.26c-2.45-.63-7.67-.2-10.36,2.93-5.17-2-10.12-9.12-10-13.6a6.25,6.25,0,0,1,3.88-1.68S202,181.56,206.84,188.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.21,187.88s.72-5.91-6.43-11.65c.72-.59,3.55.08,3.55.08s8.36,3.59,8.11,12.9A7.17,7.17,0,0,0,211.21,187.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.72,156.18a7.32,7.32,0,0,1-1.18-.65.22.22,0,0,1,0-.32.26.26,0,0,1,.34-.06,6.77,6.77,0,0,0,5.83.85.23.23,0,1,1,.16.43A7.18,7.18,0,0,1,197.72,156.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.82,173.88a19.87,19.87,0,0,0-10.25-.57c-2.28.36-6.21-1.69-8.86-4.93a5.12,5.12,0,0,0,4.59,5.93c-3.54,2.5-10.11-.27-10.86-4.88s4.3-4.57,1.22-12.65,5.11-4.49,7.74-16.51,15.58-11,17.73-6.55c7.43-3.06,11.12,1.44,13.95,8.22,2.51,6,2,10.69,5.7,20.63C313.34,172,299.43,176.88,288.82,173.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.34,173.39a4.07,4.07,0,0,1-1.35-.26,9.65,9.65,0,0,1-5.41-6.17.25.25,0,1,1,.48-.14,9.12,9.12,0,0,0,5.1,5.84,2.51,2.51,0,0,0,2.23-.07.24.24,0,0,1,.34.06.25.25,0,0,1-.06.35A2.29,2.29,0,0,1,275.34,173.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.16,154.52h-.05a.26.26,0,0,1-.2-.29c1.4-8,.12-14.25-3.59-17.65a9.08,9.08,0,0,0-8.51-2.11.25.25,0,0,1-.13-.48,9.59,9.59,0,0,1,9,2.22c2.22,2,5.67,7.1,3.74,18.1A.25.25,0,0,1,306.16,154.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65,237.48s0,54-3.28,83.26c-.34,27.46-6.61,89.5-6.61,89.5h-6.93c-1.17-30.78-9.74-59.52-4-86.67-13.33-53.32-7.15-86-7.15-86Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.15,237.52s-11.32,59.9-15.24,85.43c-4.11,26.81-10.23,78.83-10,87.29h-6s-10.05-52.62-.75-86.36c-7.67-75.86,8.31-86.36,8.31-86.36Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.12,189.31c.1,2.63.1,5.23.14,7.85s0,5.22,0,7.84c-.08,5.23-.25,10.45-.65,15.78l-.12-1.17c0,.16,0,.14-.24-.09a1.72,1.72,0,0,0-1.09-.46c-.27,0-.19.12,0,.13a3.19,3.19,0,0,0,.9-.14,14,14,0,0,0,2.44-.93c.86-.36,1.76-.87,2.59-1.28l.21-.1a2.27,2.27,0,0,1,2.86,3.34,22.79,22.79,0,0,1-2.25,2.71,16.62,16.62,0,0,1-2.9,2.36,10.37,10.37,0,0,1-2,1,6.65,6.65,0,0,1-3.09.36,5.83,5.83,0,0,1-2-.64,6.09,6.09,0,0,1-1.71-1.35,7.63,7.63,0,0,1-1.56-2.92,2.39,2.39,0,0,1-.12-.78v-.4c0-5.05-.07-10.24-.15-15.4l-.11-7.76-.07-7.76a4.5,4.5,0,0,1,9-.21Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.69,178.45c6.32,4.24,9,13.53,9.15,19.36-2.83,6.05-13,7-13,7s-2.93-10.89-2.68-16.2S306.06,176,309.69,178.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,188.19a11.68,11.68,0,0,0-11-11.65c-1.71-.11-3.5-.2-5.23-.22a111.17,111.17,0,0,0-16,1.19c-1.52.18-3,.41-4.39.66a9.11,9.11,0,0,0-7.25,11.21c5.8,21.87,6.61,37.87,4.41,47.68,0,0-7,9.31-10.14,30.65-2.77,18.64-.09,50.66-3.11,67.54,10.86,7.77,45.76,6.59,51,2.16-.63-34.16,10-76.56,4.66-97.21,5.33-8,4.9-25.61-4.66-33.2C320.6,200.74,315,196.32,315,188.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,241a70,70,0,0,1-19.22,1.22S310.72,246.53,315.32,241Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.28,221.65c-3.22-.47-3.33-5.23-3.33-5.23l-1.36-2.34a1.6,1.6,0,0,1,.77-2.42L318,211a3.25,3.25,0,0,1,3.52,1l.6.71a6.7,6.7,0,0,1,1.62,4.07l.07,2.11a3.43,3.43,0,0,1-.25,1.36,3,3,0,0,1-3.24,1.45Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.34,308.43c-.95-13.74,0-34.29,8.39-45.81C299.54,277.23,293.34,308.43,293.34,308.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.43,159.46c1.27,5,2.76,14.36-.65,18a42.73,42.73,0,0,1,21,14.85c3.75-12-5.06-16-5.06-16-5.8-.94-5.87-5.19-5.08-9.24Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.6,162.57l6,4.5a16.79,16.79,0,0,0-.35,2.86c-2.2-.15-5.33-2.32-5.68-4.59A7.71,7.71,0,0,1,287.6,162.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,150.47c2.43,8.18,3.29,11.7,8.42,14.91,7.72,4.84,17.11-.13,17.14-8.92,0-7.92-4-20-12.75-21.24S275.1,142.29,277.53,150.47Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,134.35c6.28,8-9.64,5.77-8.14,12.49s-6.73,8.3-4.79,13.44C267,158.62,272,130.16,290,134.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.16,135.1c1.48,5.18,8.22,2.91,11.91,5.92C299.35,135.1,290,132.82,288.16,135.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,149.7c.15.68.64,1.14,1.09,1s.68-.75.52-1.42-.65-1.14-1.09-1S289.25,149,289.41,149.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.8,147.7c.16.68.65,1.13,1.09,1s.68-.75.52-1.43-.64-1.13-1.09-1S297.65,147,297.8,147.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,146.36l1.52-.89S299.12,147,298.14,146.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.23,148.8a17.91,17.91,0,0,0,3.43,3.7,3.09,3.09,0,0,1-2.32,1.07Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.49,158.68a5.35,5.35,0,0,0,4.07,1.9c2-.05,2.32-2.33,1.23-4.2-1-1.69-3.2-3.69-4.92-2.73S276.13,157.14,277.49,158.68Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.82,146.8a.45.45,0,0,0,.22-.25,3.41,3.41,0,0,1,2-2.18.42.42,0,0,0,.3-.5.39.39,0,0,0-.5-.28,4.16,4.16,0,0,0-2.63,2.72.4.4,0,0,0,.26.51A.44.44,0,0,0,287.82,146.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.88,143.66a.38.38,0,0,0,.28-.11.41.41,0,0,0,0-.58,4,4,0,0,0-3.46-1.35.41.41,0,0,0,.12.81,3.18,3.18,0,0,1,2.73,1.1A.36.36,0,0,0,300.88,143.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74,148.36l1.53-.88S290.72,149,289.74,148.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,233.29l7.53-1.34-1,8.7s-5.65-.34-8.89-3l-.28-1.15C291.77,234.63,292.21,234,294,233.29Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,235.75l-.95,3.67a2.17,2.17,0,0,1-2.48,1.6l-2.11-.37,1-8.7,3.21,1.23A2.17,2.17,0,0,1,306.06,235.75Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.53,189.14c-1.39,5.18-2.81,10.44-4.13,15.64-.64,2.6-1.26,5.21-1.82,7.78-.28,1.29-.52,2.57-.73,3.81-.1.62-.19,1.23-.26,1.81s-.11,1.14-.12,1.54v.46a3.58,3.58,0,0,0,.08.43,4.42,4.42,0,0,0,.42,1,9.3,9.3,0,0,0,1.86,2.24,29.63,29.63,0,0,0,6,4,63,63,0,0,0,7.11,3.26c2.44,1,5,1.89,7.47,2.7l.09,0a2.23,2.23,0,0,1-1,4.34A70.4,70.4,0,0,1,278,234.05a33.65,33.65,0,0,1-8-4.4,16.91,16.91,0,0,1-3.65-3.78,11.69,11.69,0,0,1-1.39-2.68,13.14,13.14,0,0,1-.44-1.55c0-.27-.09-.54-.13-.81l-.07-.76a24,24,0,0,1,0-2.56c.05-.78.11-1.52.19-2.26.16-1.47.37-2.88.6-4.27.45-2.8,1-5.53,1.62-8.24,1.2-5.43,2.55-10.75,4.13-16.08a4.5,4.5,0,0,1,8.67,2.44Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.19,179.39c-5,2.35-7.29,5.91-11.09,15.72,1.33,6.54,12.92,10.41,12.92,10.41a76.13,76.13,0,0,0,4.09-12.44C282.12,187.86,280.27,177,275.19,179.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,410.29a.62.62,0,0,1,.63-.39l6.44-.09a3.54,3.54,0,0,1,1.94.41,24.25,24.25,0,0,0,9.69,3.46c1.37.21.75,2.52-2.47,2.55-5.33.06-6.29-.34-10.84-.29-3.88,0-2,.22-5.11.29-.74,0-1.35-.46-1.25-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.15,410.29a.64.64,0,0,1,.64-.39l5.24-.09a3.46,3.46,0,0,1,1.93.41c1.88,1.31,1.64,2.81,6,3.46,1.36.21.69,2.52-2.53,2.55-5.33.06-5-.29-7.16-.29s-.84.22-3.93.29c-.74,0-1.34-.46-1.22-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.31,188.26c-2.45-.63-7.67-.2-10.36,2.93-5.18-2-10.13-9.12-10-13.6a6.23,6.23,0,0,1,3.87-1.68S295.49,181.56,300.31,188.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.67,187.88s.73-5.91-6.42-11.65c.72-.59,3.54.08,3.54.08s8.36,3.59,8.12,12.9A7.19,7.19,0,0,0,304.67,187.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.19,156.18a7.4,7.4,0,0,1-1.19-.65.22.22,0,0,1,0-.32.26.26,0,0,1,.34-.06,6.77,6.77,0,0,0,5.83.85.24.24,0,0,1,.31.13.24.24,0,0,1-.15.3A7.18,7.18,0,0,1,291.19,156.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.92,175.16a20,20,0,0,0-9.84-2.92c-2.3-.17-5.65-3.07-7.48-6.83a5.11,5.11,0,0,0,3.09,6.82c-4,1.62-9.77-2.59-9.43-7.25s5.23-3.45,4.09-12,6-3.18,11.34-14.27,17.69-7.1,18.77-2.29c7.93-1.26,10.49,4,11.68,11.21,1.05,6.41-.56,10.85.79,21.39C406.22,179,391.56,180.53,381.92,175.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,170.27a4,4,0,0,1-1.36-.27,9.62,9.62,0,0,1-5.4-6.16.24.24,0,0,1,.17-.31.25.25,0,0,1,.31.17,9.09,9.09,0,0,0,5.09,5.83,2.5,2.5,0,0,0,2.23-.06.25.25,0,0,1,.29.41A2.31,2.31,0,0,1,368.64,170.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.18,160.52a.23.23,0,0,1-.11,0,.26.26,0,0,1-.11-.34c3.65-7.24,4.24-13.6,1.67-17.93a9.09,9.09,0,0,0-7.53-4.48.25.25,0,0,1,0-.5,9.56,9.56,0,0,1,7.94,4.73c1.54,2.59,3.37,8.43-1.65,18.41A.26.26,0,0,1,402.18,160.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,237.48s0,54-3.29,83.26c-.33,27.46-6.6,89.5-6.6,89.5h-6.93c-1.17-30.78-9.74-59.52-4.05-86.67-13.32-53.32-7.14-86-7.14-86Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.89,237.52s-11.32,59.9-15.24,85.43c-4.11,26.81-10.23,78.83-9.95,87.29h-6s-10-52.62-.75-86.36c-7.67-75.86,8.31-86.36,8.31-86.36Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.77,190.3c-.42,2.35-.86,4.85-1.2,7.28s-.68,4.9-.95,7.34-.44,4.86-.51,7.23a36.82,36.82,0,0,0,.33,6.76l-.41-1.1c-.1-.13-.4-.29-.33-.18a1.67,1.67,0,0,0,.92.28,14.24,14.24,0,0,0,3.78-.24c1.41-.23,2.87-.59,4.33-1s3-.86,4.39-1.3l.11,0a2.25,2.25,0,0,1,2,4,42.38,42.38,0,0,1-4.3,2.71,36.2,36.2,0,0,1-4.71,2.17,19.35,19.35,0,0,1-5.64,1.25,10,10,0,0,1-3.78-.52,7.33,7.33,0,0,1-3.89-3.22,4.13,4.13,0,0,1-.38-1l0-.12a40.88,40.88,0,0,1-1-8.44c-.07-2.73,0-5.39.22-8s.49-5.25.85-7.85.78-5.13,1.36-7.79a4.5,4.5,0,0,1,8.83,1.73Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,178.45c6.32,4.24,9,13.53,9.15,19.36-2.83,6.05-13,7-13,7s-2.93-10.89-2.68-16.2S399.8,176,403.43,178.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.7,188.19a11.69,11.69,0,0,0-11-11.65c-1.71-.11-3.5-.2-5.23-.22a111.06,111.06,0,0,0-16,1.19c-1.52.18-3,.41-4.39.66a9.11,9.11,0,0,0-7.25,11.21c5.8,21.87,6.61,37.87,4.41,47.68,0,0-7,9.31-10.15,30.65-2.76,18.64-.09,50.66-3.1,67.54,10.86,7.77,43.38,6.71,48.47,2.16-1.43-34.14,5.54-78.87.24-99.52,2.12-11.45,2.66-24,3.09-31C415.18,200.59,408.69,196.32,408.7,188.19Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,229.7c.68-8.25,19.49-40.64,31.85-40.18s15.68,9.91,11.64,21.59-15.39,24.73-28.71,26.42S378.2,234.45,378.6,229.7Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,229.7c.68-8.25,19.49-40.64,31.85-40.18s15.68,9.91,11.64,21.59-15.39,24.73-28.71,26.42S378.2,234.45,378.6,229.7Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.45,199.72c3.23-6.3,10-7.69,14.37-5.34s2.12,10.34-1.1,12.49S395.93,208.55,400.45,199.72Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.07,214.35c-6.27,0-11.42-.9-12.84-2.52a1.33,1.33,0,0,1-.24-1.54.25.25,0,1,1,.45.21.83.83,0,0,0,.17,1c2.41,2.75,19.21,3.61,31.49-.39a.25.25,0,1,1,.15.47A65.3,65.3,0,0,1,401.07,214.35Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.3,228.33a18.93,18.93,0,0,1-6.09-1.11,23.17,23.17,0,0,1-13.91-12.64.26.26,0,0,1,.13-.33.25.25,0,0,1,.33.14,22.68,22.68,0,0,0,13.61,12.36c4.08,1.41,7.92,1.45,10.28.11a.25.25,0,1,1,.25.43A9.29,9.29,0,0,1,406.3,228.33Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,198.35a10.48,10.48,0,0,0-2,.86.82.82,0,0,0,0,1.42,4.19,4.19,0,0,0,.79.34Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.17,198.61a.25.25,0,0,1,.17.08,1.88,1.88,0,0,0,1.56.69.25.25,0,0,1,.27.21.23.23,0,0,1-.2.26,2.44,2.44,0,0,1-2-.86.24.24,0,0,1,.19-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.05,197.41a.28.28,0,0,1,.09.16.23.23,0,0,1-.2.26,2.23,2.23,0,0,1-2-.67.23.23,0,0,1,0-.33.25.25,0,0,1,.33,0,1.78,1.78,0,0,0,1.59.52A.27.27,0,0,1,406.05,197.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.9,203.15a4.54,4.54,0,0,0,.83-.24.15.15,0,0,0,.08-.2.18.18,0,0,0-.21-.08,4.4,4.4,0,0,1-3.78-.26.15.15,0,0,0-.21,0,.16.16,0,0,0,.05.21A4.6,4.6,0,0,0,408.9,203.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.92,193.07c-3.79.71-3,3.67.52,4.33s1.7-1.36,1.7-1.36c.43.88-1.37.94-1.9,0-.75-1.41,7.47.45,5.89-1.23S410.57,192.94,409.92,193.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.54,218.45c-2.05-2.52,1.1-6.1,1.1-6.1l.58-2.64a1.61,1.61,0,0,1,2.21-1.26l1.63.58a3.26,3.26,0,0,1,1.94,3.1l-.05.93a6.59,6.59,0,0,1-1.56,4.09l-1.38,1.6a3.27,3.27,0,0,1-1.1.83,3,3,0,0,1-3.37-1.13Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.64,308.43c-.95-13.74,0-34.29,8.39-45.81C390.83,277.23,384.64,308.43,384.64,308.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.17,159.46c1.27,5,2.76,14.36-.65,18a42.68,42.68,0,0,1,21,14.85c3.76-12-5-16-5-16-5.8-.94-5.87-5.19-5.08-9.24Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.34,162.57l6.05,4.5a16.79,16.79,0,0,0-.35,2.86c-2.2-.15-5.33-2.32-5.68-4.59A7.71,7.71,0,0,1,381.34,162.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.88,148.35c0,8.54-.23,12.15,3.75,16.71,6,6.87,16.41,4.82,19-3.58,2.32-7.57,2-20.25-6.05-24S375.92,139.82,375.88,148.35Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.44,136.51c3.68,9.51-8.25,5.07-8.75,11.93s-11.51,3.67-11.14,9.15C363.47,153.11,376.47,127.31,392.44,136.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.51,136.71c-.09,5.39,7,5.17,9.68,9.12C401.22,140,392.93,135.07,390.51,136.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,153.77c0,.7.29,1.27.75,1.3s.87-.53.91-1.22-.29-1.27-.75-1.29S388,153.08,388,153.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.61,154.28c-.05.7.29,1.28.75,1.3s.86-.53.91-1.22-.29-1.27-.75-1.29S396.65,153.59,396.61,154.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.32,153.1l1.71-.41S398.08,154,397.32,153.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.78,154.88a18.26,18.26,0,0,0,2.21,4.54,3.08,3.08,0,0,1-2.53.35Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.47,156.2a5.36,5.36,0,0,0,3.34,3c1.91.52,2.89-1.56,2.39-3.67-.45-1.9-2-4.46-3.91-4S372.62,154.33,373.47,156.2Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.31,150.53a.42.42,0,0,0,.28-.17,3.37,3.37,0,0,1,2.6-1.49.43.43,0,0,0,.43-.4.41.41,0,0,0-.4-.42,4.22,4.22,0,0,0-3.3,1.85.39.39,0,0,0,.39.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.72,151.31a.39.39,0,0,0,.3,0,.42.42,0,0,0,.21-.55,4,4,0,0,0-2.92-2.3.44.44,0,0,0-.47.36.4.4,0,0,0,.35.45,3.22,3.22,0,0,1,2.29,1.85A.41.41,0,0,0,400.72,151.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,152.58l1.71-.4S389.46,153.44,388.7,152.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,226.42l7.65-.31-2.16,8.49s-5.56-1.1-8.41-4.19l-.13-1.18C380,227.45,380.55,226.84,382.4,226.42Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,230.49,392.6,234a2.18,2.18,0,0,1-2.67,1.25l-2-.65,2.16-8.49,3,1.65A2.17,2.17,0,0,1,394,230.49Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.19,189.37c-1.56,4.77-3.13,9.63-4.62,14.44-.75,2.41-1.42,4.83-2.09,7.22s-1.24,4.81-1.6,7c-.05.27-.09.54-.11.78s0,.49-.07.69a3.48,3.48,0,0,0,0,.88,2.85,2.85,0,0,0,.72,1.45,12,12,0,0,0,5,2.8,43,43,0,0,0,6.92,1.58c2.4.37,4.93.61,7.33.76h.08a2.24,2.24,0,0,1,.23,4.44c-1.39.23-2.68.37-4,.48s-2.68.18-4,.18a40.53,40.53,0,0,1-8.26-.74,18.14,18.14,0,0,1-8.64-3.94,10.6,10.6,0,0,1-3.16-5.07,11.08,11.08,0,0,1-.38-2.93c0-.44,0-.86,0-1.23s.05-.77.09-1.14a66.52,66.52,0,0,1,1.41-8.08c.57-2.59,1.26-5.11,1.95-7.63,1.39-5,2.94-9.95,4.69-14.88a4.5,4.5,0,0,1,8.52,2.89Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.92,179.39c-5,2.35-7.28,5.91-11.08,15.72,1.33,6.54,12.92,10.41,12.92,10.41a76.13,76.13,0,0,0,4.09-12.44C375.85,187.86,374,177,368.92,179.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.08,410.29a.62.62,0,0,1,.63-.39l6.44-.09a3.54,3.54,0,0,1,1.94.41,24.25,24.25,0,0,0,9.69,3.46c1.37.21.75,2.52-2.47,2.55-5.33.06-6.29-.34-10.84-.29-3.88,0-2,.22-5.12.29-.74,0-1.34-.46-1.24-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.89,410.29a.63.63,0,0,1,.64-.39l5.24-.09a3.46,3.46,0,0,1,1.93.41c1.88,1.31,1.64,2.81,6,3.46,1.36.21.69,2.52-2.53,2.55-5.33.06-5-.29-7.16-.29s-.84.22-3.93.29c-.74,0-1.34-.46-1.22-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.05,188.26c-2.45-.63-7.67-.2-10.36,2.93-5.18-2-10.13-9.12-10-13.6a6.23,6.23,0,0,1,3.87-1.68S389.23,181.56,394.05,188.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.41,187.88s.73-5.91-6.42-11.65c.72-.59,3.54.08,3.54.08s8.36,3.59,8.11,12.9A7.17,7.17,0,0,0,398.41,187.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,160.49a8.64,8.64,0,0,1-.95-1,.22.22,0,0,1,.05-.32.26.26,0,0,1,.35,0,6.79,6.79,0,0,0,5.33,2.5.24.24,0,0,1,.26.21.23.23,0,0,1-.23.24A7.13,7.13,0,0,1,387.82,160.49Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.2,99.93,213.57,110.5a9.23,9.23,0,0,1-10-6.62L191.68,58.8a7.11,7.11,0,0,1,5.89-9L267.2,39.2a9.23,9.23,0,0,1,10,6.62L289.09,90.9A7.11,7.11,0,0,1,283.2,99.93Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.2,99.93,213.57,110.5a9.23,9.23,0,0,1-10-6.62L191.68,58.8a7.11,7.11,0,0,1,5.89-9L267.2,39.2a9.23,9.23,0,0,1,10,6.62L289.09,90.9A7.11,7.11,0,0,1,283.2,99.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,98.15l-.79-.52a9.55,9.55,0,0,0,1.2-7.8L287.42,63l.91-.24,7.07,26.81A10.52,10.52,0,0,1,294.07,98.15Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.32,
    y: 102.51,
    width: 9.46,
    height: 0.95,
    transform: "translate(-12.28 43.57) rotate(-8.65)",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.3,99.46,216.67,110a9.22,9.22,0,0,1-10-6.62L194.78,58.33a7.1,7.1,0,0,1,5.89-9L270.3,38.73a9.23,9.23,0,0,1,10,6.62l11.87,45.08A7.11,7.11,0,0,1,286.3,99.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.16 93.48 221.15 102.13 208.81 55.28 265.82 46.63 278.16 93.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.16 93.48 221.15 102.13 208.81 55.28 265.82 46.63 278.16 93.48",
    style: {
      fill: "#845EC2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.3 101.35 221.15 102.13 211.74 66.4 216.88 65.62 226.3 101.35",
    style: {
      fill: "#845EC2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.96 54.5 208.81 55.28 211.74 66.4 216.88 65.62 213.96 54.5",
    style: {
      fill: "#845EC2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.96 54.5 265.82 46.63 268.75 57.75 216.88 65.62 213.96 54.5",
    style: {
      fill: "#845EC2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.05,82.88l-48.19,17.77c-20.66-6.23-37.88-32-39.18-44.77l51.46-9.29C269.44,59.32,283.39,76.65,304.05,82.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.05,82.88l-48.19,17.77c-20.66-6.23-37.88-32-39.18-44.77l51.46-9.29C269.44,59.32,283.39,76.65,304.05,82.88Z",
    style: {
      fill: "#845EC2",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,46.59l-25.73,4.64-25.73,4.65h0c.37,3.61,2,8.27,4.66,13.24l51-10.7A30.23,30.23,0,0,1,268.14,46.59Z",
    style: {
      fill: "#845EC2",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.77,84.66l5.93-2.21a6.4,6.4,0,0,0,2.2,1.26,3.55,3.55,0,0,0,1.88.06A1.5,1.5,0,0,0,268.13,82q-.17-1-2.46-4a3.86,3.86,0,0,1-1.19,1.94A5.87,5.87,0,0,1,262,81a12.63,12.63,0,0,1-6.88-.42,13.53,13.53,0,0,1-6.1-3.81,6.65,6.65,0,0,1-1.84-3.54,3.35,3.35,0,0,1,1-3,9,9,0,0,1,4.19-1.94A16,16,0,0,1,265,70a23.77,23.77,0,0,1,6.09,5q4.4,4.86,3.76,7.79t-5.38,4.07a17.09,17.09,0,0,1-4.87.58,13.73,13.73,0,0,1-4-.79A17,17,0,0,1,256.77,84.66Zm4.78-11a7.24,7.24,0,0,0-3-2,5.35,5.35,0,0,0-3.09-.26c-.86.21-1.35.63-1.48,1.27s.27,1.46,1.17,2.46a7.5,7.5,0,0,0,3,2.09,5.07,5.07,0,0,0,2.94.25c.92-.22,1.45-.67,1.59-1.33S262.42,74.66,261.55,73.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,59.67l-.27-1a10.88,10.88,0,0,0,9-13.85,14.1,14.1,0,0,0-15.36-10.15,10.89,10.89,0,0,0-9,13.85l-1,.16a11.79,11.79,0,0,1,9.78-15,15.28,15.28,0,0,1,16.63,11A11.78,11.78,0,0,1,221.34,59.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.48,56.62l-.26-1a10.89,10.89,0,0,0,9-13.85A14.11,14.11,0,0,0,234.9,31.63a10.88,10.88,0,0,0-9,13.85l-1,.15a11.78,11.78,0,0,1,9.79-15,15.24,15.24,0,0,1,16.62,11A11.79,11.79,0,0,1,241.48,56.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.63,53.56l-.26-1a10.88,10.88,0,0,0,9-13.85A14.09,14.09,0,0,0,255,28.57a10.89,10.89,0,0,0-9,13.85l-1,.15a11.78,11.78,0,0,1,9.78-15,15.26,15.26,0,0,1,16.63,11A11.78,11.78,0,0,1,261.63,53.56Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientLogin);
export default __webpack_public_path__ + "static/media/Patient_login.d488bad0eeb6488a93a26e27ac5bb0a5.svg";
export { ForwardRef as ReactComponent };